.c-vacation-calculator-intro {
  margin-top: 1.5em;
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFwcC9jb21wb25lbnRzL3ZhY2F0aW9uX2NhbGN1bGF0b3IvaW50cm9fY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGlCQUFpQjtBQUNuQiIsImZpbGUiOiJhcHAvY29tcG9uZW50cy92YWNhdGlvbl9jYWxjdWxhdG9yL2ludHJvX2NvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuYy12YWNhdGlvbi1jYWxjdWxhdG9yLWludHJvIHtcbiAgbWFyZ2luLXRvcDogMS41ZW07XG59XG4iXX0= */